/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import MainContainer from "../../layout/MainContainer";
import {
  Card,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Button,
  TableBody,
  MenuItem,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BlockIcon from "@mui/icons-material/Block";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import SearchBar from "../../components/SearchBar";
import { Comment } from "../../types/General";
import { Loader, showError, showToast } from "../../constants";
import { Pagination } from "../../components";
import { isValidInput } from "../../utils/validations";
import { GetComments, UpdateCommentStatus } from "../../services/home";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const Comments = () => {
  const navigate = useNavigate();

  const [allComments, setAllComments] = useState<Comment[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [opened, setOpened] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [likes, setLikes] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  let totalPages = Math.ceil(totalCount / 10);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, item: any) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedItem(item);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedItem(null);
  };

  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  const getComments = async (
    likes: string,
    startDate: string,
    endDate: string
  ) => {
    try {
      setLoading(true);
      const response = (await GetComments({
        limit: 10,
        skip: page - 1,
        search: debouncedSearchTerm,
        startDate,
        likes,
        endDate,
      })) as {
        code: number;
        count: number;
        data: Comment[];
      };
      if (response?.code === 200) {
        setLoading(false);
        setAllComments(response?.data || []);
        setTotalCount(response?.count || 10);
        setLoading(false);
      } else {
        setLoading(false);
        setAllComments([]);
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const updateStatus = async (status: string, id: string, item: any) => {
    try {
      setLoading(true);
      console.log();
      const response = (await UpdateCommentStatus(id, {
        isDeleted: Number(status),
        commentData: item,
      })) as {
        status: number;
      };

      if (response?.status === 200) {
        setLoading(false);
        showToast("Status updated successfully");
        let comments = [...allComments];
        let idx = -1;
        idx = comments?.findIndex((item) => item?._id === id);
        if (idx > -1) {
          comments[idx] = {
            ...comments[idx],
            isDeleted: Number(status),
          };
        }
        setAllComments([...comments]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      showError("something went wrong");
      console.log(error);
    }
  };

  const applyFilter = () => {
    getComments(
      likes,
      startDate ? dayjs(startDate).format("YYYY-MM-DD") : "",
      endDate ? dayjs(endDate).format("YYYY-MM-DD") : ""
    );
    setOpened(false);
  };

  const resetValues = () => {
    setStartDate(null);
    setEndDate(null);
    setPage(1);
    getComments("", "", "");
    setOpened(false);
  };

  useEffect(() => {
    getComments(
      likes,
      startDate ? dayjs(startDate).format("YYYY-MM-DD") : "",
      endDate ? dayjs(endDate).format("YYYY-MM-DD") : ""
    );
  }, [debouncedSearchTerm, page]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MainContainer>
        <Loader isLoad={loading} />
        <div onClick={() => setOpened(false)} className="main_loyout">
          <div className="dashboard">
            <div className="heading-bread">
              <h1 className="mn_hdng"> Comments</h1>
            </div>
          </div>
          <Card className="cards">
            <Box className="cards_header">
              <Grid
                container
                spacing={2}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item>
                  <SearchBar
                    placeholder="Search by comment or author"
                    searchTerm={searchTerm}
                    setDebouncedSearchTerm={setDebouncedSearchTerm}
                    value={searchTerm}
                    onCross={() => setSearchTerm("")}
                    onChange={(val: any) => {
                      if (isValidInput(val.target.value)) {
                        setPage(1);
                        setSearchTerm(val.target.value);
                      }
                    }}
                  />
                </Grid>
                <Grid item>
                  <div className="parent-box">
                    <Button
                      onClick={(e: any) => {
                        e.stopPropagation();
                        setOpened(true);
                      }}
                      id="basic-button"
                      variant="contained"
                    >
                      Filter
                    </Button>
                    {opened ? (
                      <div
                        onClick={(e) => e.stopPropagation()}
                        className="filter-options"
                      >
                        <h3>Filter Options</h3>
                        <div className="filter-div">
                          <FormControl fullWidth>
                            <label>Criteria</label>
                            <select
                              onChange={(val) => setLikes(val.target.value)}
                              value={likes}
                              name="cars"
                              id="cars"
                            >
                              <option value="">Sort</option>
                              <option value="lth">Low to High</option>
                              <option value="htl">High to Low</option>
                            </select>
                          </FormControl>
                          <FormControl fullWidth>
                            <label>Period</label>
                            <div
                              className="range-picker"
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "20px",
                              }}
                            >
                              <DatePicker
                                sx={{ height: "40px" }}
                                value={startDate}
                                onChange={(val) => {
                                  setStartDate(val);
                                }}
                                disableFuture
                                format="DD/MM/YYYY"
                                label="From"
                                // timezone="Asia/Kolkata"
                              />
                              <DatePicker
                                sx={{ height: "40px" }}
                                value={endDate}
                                minDate={startDate}
                                onChange={(val) => {
                                  setEndDate(val);
                                }}
                                disableFuture
                                format="DD/MM/YYYY"
                                label="Till"
                                // timezone="Asia/Kolkata"
                              />
                            </div>
                          </FormControl>

                          <div className="button-div">
                            <Button onClick={resetValues} id="basic-button">
                              Reset
                            </Button>
                            <Button
                              onClick={applyFilter}
                              id="basic-button"
                              variant="contained"
                            >
                              Apply
                            </Button>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </Grid>
              </Grid>
            </Box>
            <TableContainer className="table_container">
              <Box className="heading"></Box>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">AUTHOR</TableCell>
                    <TableCell align="center">UID</TableCell>
                    <TableCell align="center">PARENT UID</TableCell>
                    <TableCell align="center">POST UID</TableCell>
                    <TableCell align="center">
                      COMMENT <span></span>
                    </TableCell>
                    <TableCell align="center">POSTED</TableCell>
                    <TableCell align="center">LIKES</TableCell>
                    <TableCell align="right">Actions</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {allComments?.length ? (
                    allComments?.map((item, i) => {
                      const output = item?.message.replace(
                        /\[@[^\]]+\]/g,
                        (match) => {
                          // Extract only the name part without brackets and colon
                          return match.slice(2, -1).split(":")[0];
                        }
                      );
                      const words = output.split(" ");

                      // Take the first six words
                      const truncatedTitle = words.slice(0, 6).join(" ");

                      // If the title has more than six words, add an ellipsis
                      const displayTitle =
                        words.length > 6
                          ? truncatedTitle + "..."
                          : truncatedTitle;
                      return (
                        <TableRow
                          sx={{ cursor: "pointer" }}
                          onClick={() =>
                            navigate(`/comments/${item?._id}`, {
                              state: { item },
                            })
                          }
                          onMouseDown={(e: React.MouseEvent) => {
                            // Middle click (button 1) or Ctrl+Click
                            if (e.button === 1 || (e.button === 0 && (e.ctrlKey || e.metaKey))) {
                              e.preventDefault();
                              window.open(`/comments/${item?._id}`, '_blank');
                            }
                          }}
                        >
                          <TableCell align="left">
                            {item?.user?.username || "N/A"}
                          </TableCell>
                          <TableCell align="center">
                            {item?.uuid || "N/A"}
                          </TableCell>
                          <TableCell align="center">
                            {item?.parentUuid || "N/A"}
                          </TableCell>
                          <TableCell align="center">
                            {item?.post?.uuid || "N/A"}
                          </TableCell>
                          <TableCell align="center">
                            {displayTitle || "N/A"}
                          </TableCell>
                          <TableCell align="center">
                            {moment(item?.createdAt).format(
                              "MMM DD, YYYY (HH:mm)"
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {item?.likeCount}
                          </TableCell>
                          <TableCell align="right">
                            <IconButton
                              size="small"
                              onClick={(e) => handleMenuOpen(e, item)}
                              sx={{
                                backgroundColor: "#f1f5f9",
                                "&:hover": {
                                  backgroundColor: "#e2e8f0",
                                },
                              }}
                            >
                              <MoreVertIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell
                        align="center"
                        colSpan={10}
                        sx={{ color: "#051140" }}
                      >
                        No Comments Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
          <Pagination
            module={allComments || []}
            page={page}
            onPageChange={onPageChange}
            totalPages={totalPages}
          />

          {/* Actions Menu */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.15))",
                mt: 1,
                minWidth: 160,
                borderRadius: "10px",
                "& .MuiMenuItem-root": {
                  padding: "10px 16px",
                  fontSize: "13px",
                  fontWeight: 500,
                  gap: "10px",
                },
              },
            }}
          >
            <MenuItem
              onClick={() => {
                navigate(`/comments/${selectedItem?._id}`, {
                  state: { item: selectedItem },
                });
                handleMenuClose();
              }}
              onMouseDown={(e: React.MouseEvent) => {
                // Middle click (button 1) or Ctrl+Click
                if (e.button === 1 || (e.button === 0 && (e.ctrlKey || e.metaKey))) {
                  e.preventDefault();
                  window.open(`/comments/${selectedItem?._id}`, '_blank');
                  handleMenuClose();
                }
              }}
            >
              <ListItemIcon>
                <VisibilityIcon fontSize="small" sx={{ color: "#64748b" }} />
              </ListItemIcon>
              <ListItemText>View</ListItemText>
            </MenuItem>

            <MenuItem
              onClick={() => {
                updateStatus(
                  selectedItem?.isDeleted === 1 ? "2" : "1",
                  selectedItem?._id,
                  selectedItem
                );
                handleMenuClose();
              }}
            >
              <ListItemIcon>
                {selectedItem?.isDeleted === 1 ? (
                  <BlockIcon fontSize="small" sx={{ color: "#ef4444" }} />
                ) : (
                  <CheckCircleIcon fontSize="small" sx={{ color: "#22c55e" }} />
                )}
              </ListItemIcon>
              <ListItemText>
                {selectedItem?.isDeleted === 1 ? "Disable" : "Enable"}
              </ListItemText>
            </MenuItem>
          </Menu>
        </div>
      </MainContainer>
    </LocalizationProvider>
  );
};

export default Comments;
